export default "__VITE_ASSET__jdKwADlf__"